export enum FunctionalType {
  Service = 1,
  Product = 2,
  Course = 3,
  Subscription = 4
}